import { useEffect, useState } from 'preact/hooks';
import { TRANSLATIONS_URL } from 'config/api';
import { UMBRACO_API_KEY } from 'config/env';
import fallbackData from '../mocks/en.json';

const useTranslations = (language: string) => {
  const [translations, setTranslations] = useState(fallbackData);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          `${TRANSLATIONS_URL}/handler?handle=dictionary$cc=${language}`,
          {
            headers: {
              'x-api-key': UMBRACO_API_KEY
            }
          }
        );
        const json = await res.json();
        if (!res.ok) {
          console.warn(`error loading ${language} file`);
          throw new Error('Not 2xx response');
        }
        const data = json?.views?.dictionary?.translations;

        if (typeof data === 'undefined' || data === null) {
          setTranslations(fallbackData);
          console.error(
            `translations for ${language} language is empty, will use fallback data instead`
          );
          return;
        }

        setTranslations(data);
      } catch (e) {
        setError(e);
      }
    };
    fetchData();
  }, [language]);

  return { translations, error };
};

export default useTranslations;
